import React from 'react';
import { DatePicker } from '@adsk/alloy-react-date-picker';
import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import PropTypes from 'prop-types';
var DatePickerCustomFooter = function DatePickerCustomFooter(_ref) {
  var today = _ref.today,
    reset = _ref.reset;
  var _useLocale = useLocale(function (_ref2) {
      var locale = _ref2.locale;
      return require("./i18n/".concat(locale, ".json"));
    }),
    T = _useLocale.T;
  return /*#__PURE__*/React.createElement(DatePicker.Footer, null, /*#__PURE__*/React.createElement(Button, {
    onClick: today,
    size: Button.SIZES.SMALL
  }, T.translate('TODAY')), /*#__PURE__*/React.createElement(Button, {
    variant: Button.VARIANTS.TERTIARY,
    size: Button.SIZES.SMALL,
    onClick: reset
  }, T.translate('RESET_SELECTION')));
};
DatePickerCustomFooter.propTypes = {
  today: PropTypes.func,
  reset: PropTypes.func
};
DatePickerCustomFooter.defaultProps = {
  today: undefined,
  reset: undefined
};
export default DatePickerCustomFooter;
//# sourceMappingURL=component.js.map